import { passwordRegex, phoneRegExp, whiteSpaceRegex } from "@/constants"

export const validationPhone = () => {
    return [
        {
            pattern: phoneRegExp,
            message: "Số điện thoại không hợp lệ!"
        }, 
        {
            len: 10,
            message: 'Số điện thoại cần có 10 chữ số!',
        },
    ]
}

export const validationPassword = (prefixMsg) => {
    return [
        { required: true, message: `Please enter ${prefixMsg.toLowerCase()}!`},
        {
            pattern: whiteSpaceRegex,
            message: `${prefixMsg} must not start and end with a space!`
        },
        {
            pattern: passwordRegex,
            message: `${prefixMsg} can only use common letters, numbers and special characters!`
        },
        {
            min: 8,
            message: `${prefixMsg} must be at least 8 characters!`
        }
    ]
}

export const validationEmail = () => {
    return [{
        type: "email",
        message: "Email chưa đúng định dạng!"
    }]
}